import React, {Component} from 'react';
import { ChannelLogo } from '../channels/ChannelLogo';
import {LayoutSidebar} from "../../Layout";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {AgencyHeader} from "./AgencyHeader";
import {AgencyTabs} from "./AgencyTabs";
import {ConnectionsSubTabs, CONNECTIONS_TAB_EXPORT} from "./ConnectionsSubTabs";
import {DatetimeHelper} from "../../utils/DatetimeHelper";
import {FaIcon} from "../FaIcon";
import {DeleteSyncConfigurationModal} from "./DeleteSyncConfigurationModal";
import {CreateNewConfigurationModal} from "./CreateNewConfigurationModal";
import {getDataByDataSourceType} from "../../nodeToGSheet";
import {getPeriodName} from "../../periods";
import {ExecuteSyncConfigurationButton} from "./ExecuteSyncConfiguration";
import {withRouterParams} from "../../utils/withRouterParams";
import {SyncConfigurationModal} from "./SyncConfigurationModal";
import { withTranslation } from 'react-i18next';

class SyncConfigurationsComponent extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <SyncConfigurationsContent agencyId={this.props.match.params.id}/>
            </div>
        )
    }
}


class SyncConfigurationsContentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            syncConfigurations: null,
            fieldsData: null,
            editingSyncConfiguration: null,
            isModalOpen: false,
            isCopying: false,
        };
        this.handleRemoveSyncConfiguration = this.handleRemoveSyncConfiguration.bind(this);
        this.handleExecuteSyncConfiguration = this.handleExecuteSyncConfiguration.bind(this);
        this.handleSaveSyncConfiguration = this.handleSaveSyncConfiguration.bind(this);
        this.handleCreateNewSyncConfigurations = this.handleCreateNewSyncConfigurations.bind(this);
        this.openModalForEdit = this.openModalForEdit.bind(this);
        this.openModalForCopy = this.openModalForCopy.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    componentDidMount() {
        this.updateSyncConfigurations();
    }

    updateSyncConfigurations() {
        new APIClient(API_URL + 'node-to-gsheet/sync-configuration/').call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {
                this.setState({
                    syncConfigurations: data.sync_configurations,
                    fieldsData: data.fields_data
                });
            }
        })
    }

    handleRemoveSyncConfiguration() {
        const { t } = this.props;
        alert(t('sync_config.sync_deleted'));
        this.updateSyncConfigurations();
    }

    handleExecuteSyncConfiguration() {
        const { t } = this.props;
        alert(t('sync_config.sync_sent'));
        this.updateSyncConfigurations();
    }

    handleSaveSyncConfiguration() {
        this.closeModal();
        this.updateSyncConfigurations();
    }

    handleCreateNewSyncConfigurations() {
        const { t } = this.props;
        alert(t('sync_config.sync_created'));
        this.updateSyncConfigurations();
    }

    openModalForEdit(syncConfiguration) {
        this.setState({ editingSyncConfiguration: syncConfiguration, isModalOpen: true, isCopying: false });
    }

    openModalForCopy(syncConfiguration) {
        this.setState({ editingSyncConfiguration: syncConfiguration, isModalOpen: true, isCopying: true });
    }

    closeModal() {
        this.setState({ editingSyncConfiguration: null, isModalOpen: false, isCopying: false });
    }

    renderSyncConfigurations() {
        const { t } = this.props;
        if (this.state.syncConfigurations !== null) {
            return (
                <div className="table-box">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>{t('sync_config.client')}</th>
                            <th>{t('sync_config.mode')}</th>
                            <th>{t('sync_config.period')}</th>
                            <th style={{minWidth:"160px"}}>{t('sync_config.dimensions')}</th>
                            <th style={{minWidth:"160px"}}>{t('sync_config.metrics')}</th>
                            {/* <th style={{maxWidth:"140px"}}>Filtros</th> */}
                            <th>{t('sync_config.spreadsheet')}</th>
                            <th>{t('sync_config.last_sync')}</th>
                            <th/>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderSyncConfigurationsRows()}
                        </tbody>
                    </table>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        const { t } = this.props;
        return (
            <section className="section-content">
                {/* La exportación a planillas vive DENTRO de Conexiones › Exportación (D9 del
                    recorrido de la 2.1, 02/10), y se dibuja con su marco: la cabecera y las
                    pestañas de la agencia, con «Exportación» marcada. Antes tenía cabecera propia
                    («Exportación de datos») y una fila «Sincronizaciones · Conexiones» cuya segunda
                    solapa sacaba de la sección a otra pantalla, con otra cabecera y sin camino de
                    vuelta. La pestaña «Exportación» es ese camino: lleva a Data Studio, al Nodo de
                    Datos y a la tarjeta que vuelve acá. */}
                <AgencyHeader/>
                <AgencyTabs activeTab="-sixth"/>
                <ConnectionsSubTabs activeSubTab={CONNECTIONS_TAB_EXPORT}/>
                <div className="section-body h-items">
                    <div className="section-body-item -widest box">
                        <header className="box-header">
                            <h2 className="box-title">{t('sync_config.synchronizations')}</h2>
                            {this.renderCreateNewSyncConfiguration()}
                        </header>
                        {this.renderSyncConfigurations()}
                        <SyncConfigurationModal
                            isOpen={this.state.isModalOpen}
                            toggle={this.closeModal}
                            onSave={this.handleSaveSyncConfiguration}
                            syncConfiguration={this.state.editingSyncConfiguration}
                            isCopying={this.state.isCopying}
                        />
                    </div>
                </div>
            </section>
        )
    }

    renderCreateNewSyncConfiguration() {
        return (<CreateNewConfigurationModal onCreateNewSyncConfigurations={this.handleCreateNewSyncConfigurations} />)
    }

    renderDimensionsCellContent(syncConfiguration) {
        if (!syncConfiguration || !syncConfiguration.data_request || !syncConfiguration.data_request.fields_json || !this.state.fieldsData) {
            return "";
        }

        const dataRequest = syncConfiguration.data_request;
        const fieldsData = this.state.fieldsData;

        const dimensionNames = dataRequest.fields_json.map(fd => fd.name).filter(fieldId => {
            const fieldInfo = fieldsData.FIELD_DATA_BY_ID[fieldId];
            return fieldInfo && fieldInfo.type === fieldsData.FIELD_TYPES.DIMENSION;
        });

        if (dimensionNames.length === 0) {
            return "";
        }

        return (
            <ul style={{listStyle: 'disc inside', padding: '5px 0 5px 10px', margin: 0}}>
                {dimensionNames.map(fieldId => <li key={fieldId}>{fieldsData.FIELD_DATA_BY_ID[fieldId]["name"]}</li>)}
            </ul>
        );
    }

    renderMetricsCellContent(syncConfiguration) {
        if (!syncConfiguration || !syncConfiguration.data_request || !syncConfiguration.data_request.fields_json || !this.state.fieldsData) {
            return "";
        }

        const dataRequest = syncConfiguration.data_request;
        const fieldsData = this.state.fieldsData;

        const metricNames = dataRequest.fields_json.map(fd => fd.name).filter(fieldId => {
            const fieldInfo = fieldsData.FIELD_DATA_BY_ID[fieldId];
            if (fieldInfo && fieldInfo.type === fieldsData.FIELD_TYPES.METRIC) {
                return true;
            }
            if (fieldsData.CALCULATED_METRICS.includes(fieldId)) {
                return true;
            }
            return false;
        });

        if (metricNames.length === 0) {
            return "";
        }

        return (
            <ul style={{listStyle: 'disc inside', padding: '5px 0 5px 10px', margin: 0}}>
                {metricNames.map(fieldId => <li key={fieldId}>{fieldsData.FIELD_DATA_BY_ID[fieldId]["name"]}</li>)}
            </ul>
        );
    }

    renderFiltersCellContent(syncConfiguration) {
        const { t } = this.props;
        if (!syncConfiguration || !syncConfiguration.data_request || !syncConfiguration.data_request.dimensions_filters_json) {
            return t('sync_config.none');
        }

        const dimensionsFilters = syncConfiguration.data_request.dimensions_filters_json;
        const fieldsData = this.state.fieldsData;

        if (!dimensionsFilters || !Array.isArray(dimensionsFilters) || dimensionsFilters.flat().length === 0) {
            return t('sync_config.none');
        }

        const operatorTranslations = {
            'CONTAINS': t('sync_config.contains'),
            'EQUALS': t('sync_config.equals'),
            'REGEXP_PARTIAL_MATCH': t('sync_config.regexp_partial_match'),
            'REGEXP_EXACT_MATCH': t('sync_config.regexp_exact_match'),
            'IN': t('sync_config.in'),
            'BETWEEN': t('sync_config.between'),
            'IS_NULL': t('sync_config.is_null'),
        };

        const translateOperator = (op) => operatorTranslations[op] || op;

        const renderFilter = (filter, key) => {
            const fieldName = (fieldsData && fieldsData.FIELD_DATA_BY_ID[filter.fieldName] && fieldsData.FIELD_DATA_BY_ID[filter.fieldName].name) || filter.fieldName;
            const operator = translateOperator(filter.operator);
            const values = filter.values.map(v => {
                if (typeof v === 'string') return `"${v}"`;
                if (typeof v === 'boolean') return v ? t('sync_config.true') : t('sync_config.false');
                return v;
            }).join(', ');
            const type = filter.type === 'EXCLUDE' ? t('sync_config.no') : '';

            const valuesString = filter.values.length > 1 ? `[${values}]` : values;

            return (
                <div key={key}>
                    {type}<strong style={{fontWeight: '600', paddingRight: '4px'}}>{fieldName}</strong>{operator}<em> {valuesString}</em>
                </div>
            );
        };

        const elements = [];
        dimensionsFilters.forEach((filterGroup, groupIndex) => {
            if (elements.length > 0) {
                elements.push(<div key={`and-${groupIndex}`} style={{fontSize: '0.8em', color: '#666', margin: '4px 0', textAlign: 'center'}}>{t('sync_config.and')}</div>);
            }

            if (filterGroup.length > 1) {
                const groupElements = [];
                filterGroup.forEach((filter, filterIndex) => {
                    groupElements.push(renderFilter(filter, `${groupIndex}-${filterIndex}`));
                    if (filterIndex < filterGroup.length - 1) {
                        groupElements.push(<div key={`or-${groupIndex}-${filterIndex}`} style={{fontSize: '0.8em', color: '#666', margin: '4px 0', textAlign: 'center'}}>{t('sync_config.or')}</div>);
                    }
                });
                elements.push(<div key={`group-${groupIndex}`} style={{ border: '1px solid #eee', padding: '5px', borderRadius: '4px' }}>{groupElements}</div>)

            } else if (filterGroup.length === 1) {
                elements.push(renderFilter(filterGroup[0], `${groupIndex}-0`));
            }
        });

        return (
            <div style={{fontSize: '13px', textAlign: 'left'}}>
                {elements}
            </div>
        );
    }

    renderSourceTypeCellContent(syncConfiguration) {
        /**
         *  Esta función devuelve el nombre del tipo de fuente de datos y luego de un renglon vacío, en caso de que haya filtro por cuenta publicitaria o línea de negocio, el nombre.
         *     > syncConfiguration.data_request.data_source_type define el tipo de fuente de datos.
         *     > syncConfiguration.filtered_ad_account tine null o {channel, account_id, name}
         *     > syncConfiguration.filtered_business_unit tine null o {id, name}
         */
        const { t } = this.props;
        if(!syncConfiguration || !syncConfiguration.data_request || !syncConfiguration.data_request.data_source_type)
            return "";

        const sourceTypeName = getDataByDataSourceType(t)[syncConfiguration.data_request.data_source_type];

        if (syncConfiguration.filtered_ad_account) {
            return <>{sourceTypeName}<br/><small><ChannelLogo margin="0px" useOld={false} width={"15px"} height={"15px"} marginLeft={"0px"} channel={syncConfiguration.filtered_ad_account.channel}/>{syncConfiguration.filtered_ad_account.name}<br/>(Id: {syncConfiguration.filtered_ad_account.account_id})</small></>
        }

        if (syncConfiguration.filtered_business_unit) {
            return <>{sourceTypeName}<br/><small>{syncConfiguration.filtered_business_unit.name}</small></>
        }

        return sourceTypeName;
    }

    renderPeriodCellContent(syncConfiguration) {
        const { t } = this.props;
        if(!syncConfiguration || !syncConfiguration.data_request || !syncConfiguration.data_request.period)
            return "";

        return getPeriodName(syncConfiguration.data_request.period, t);
    }

    renderLastSyncCellContent(syncConfiguration) {
        const { t } = this.props;
        const lastSync = DatetimeHelper.isoToFriendlyDateTime(syncConfiguration.last_sync_at);

        if (syncConfiguration.last_run_error) {
            const lastRun = DatetimeHelper.isoToFriendlyDateTime(syncConfiguration.last_run_at);
            const tooltipText = `${t('sync_config.failed_on')} ${lastRun}\n${t('sync_config.error')} ${syncConfiguration.last_run_error}`;

            return (
                <span>
                    {lastSync}
                    <span title={tooltipText} style={{marginLeft: '5px', cursor: 'pointer'}}>
                        <FaIcon iconName="exclamation-circle" style={{color: 'red'}}/>
                    </span>
                </span>
            );
        }

        return <span>{lastSync}</span>;
    }

    renderSyncConfigurationsRows() {
        return this.state.syncConfigurations.sort((a, b) => a.id - b.id).map((syncConfiguration) => {
            return (
                <tr key={syncConfiguration.id}>
                    <td>{syncConfiguration.agency_client.name}</td>
                    <td>{this.renderSourceTypeCellContent(syncConfiguration)}</td>
                    <td>{this.renderPeriodCellContent(syncConfiguration)}</td>
                    <td>{this.renderDimensionsCellContent(syncConfiguration)}</td>
                    <td>{this.renderMetricsCellContent(syncConfiguration)}</td>
                    {/* <td className={"py-3"}>{this.renderFiltersCellContent(syncConfiguration)}</td> */}
                    <td>
                        <a href={`https://docs.google.com/spreadsheets/d/${syncConfiguration.google_spreadsheet_id}`} target="_blank" rel="noopener noreferrer">
                            {syncConfiguration.spreadsheet_name ? `${syncConfiguration.spreadsheet_name} - ${syncConfiguration.google_sheet_name}` : syncConfiguration.google_sheet_name}
                        </a>
                    </td>
                    <td>{this.renderLastSyncCellContent(syncConfiguration)}</td>
                    <td className="action-cell ">
                        {this.renderUserOperation(syncConfiguration)}
                    </td>
                </tr>
            );
        });
    }

    getStatusConstants() {
        const { t } = this.props;
        return {
            STATUS_NOT_TRIGGERED_YET: t('sync_config.status_not_triggered'),
            STATUS_TRIGGERED: t('sync_config.status_triggered'),
            STATUS_STARTED: t('sync_config.status_started'),
            STATUS_FINISHED: t('sync_config.status_finished'),
            STATUS_CANCELED: t('sync_config.status_canceled'),
            STATUS_SKIP: t('sync_config.status_skip')
        };
    }

    renderUserOperation(syncConfiguration) {
        const statusConstants = this.getStatusConstants();
        const runningStatus = [statusConstants.STATUS_NOT_TRIGGERED_YET, statusConstants.STATUS_TRIGGERED, statusConstants.STATUS_STARTED];
        const isBeingSyncedRightNow = syncConfiguration.last_execution_data && runningStatus.includes(syncConfiguration.last_execution_data.status);

        return (
            <div>
                <div style={{
                    display: "inline-block",
                    verticalAlign: "middle"
                }}>
                    <ExecuteSyncConfigurationButton onExecuteSyncConfiguration={this.handleExecuteSyncConfiguration}
                                                    syncConfigurationId={syncConfiguration.id}
                                                    isBeingSyncedRightNow={isBeingSyncedRightNow}
                    />
                    <button className="btn-icon pe-1" onClick={() => this.openModalForEdit(syncConfiguration)}>
                        <FaIcon iconName="pencil-alt"/>
                    </button>
                    <button className="btn-icon pe-1" onClick={() => this.openModalForCopy(syncConfiguration)}>
                        <FaIcon iconName="copy"/>
                    </button>
                </div>
                <div style={{
                    display: "inline-block",
                    verticalAlign: "middle"
                }}>
                    <DeleteSyncConfigurationModal onRemoveSyncConfiguration={this.handleRemoveSyncConfiguration} syncConfigurationId={syncConfiguration.id}/>
                </div>
            </div>
        );
    }
}

const SyncConfigurations = withTranslation()(SyncConfigurationsComponent);
const SyncConfigurationsContent = withTranslation()(SyncConfigurationsContentComponent);

export default withRouterParams(SyncConfigurations);